import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import {
  useAuthUser,
  usePortalPermissions,
  parseUserRole,
  isFleetOwnerRole,
  isAdminRole,
} from '@ubus/shared';
import PermissionRoute from './PermissionRoute';
import ScheduleOverview from '../pages/ScheduleOverview';

/**
 * Platform: schedule overview via jobs.view (CONF: keep overview, no daily schedule).
 * Fleet: owner_schedule.view.
 * Missing permission → home (dashboard for platform) instead of a dead-end 403.
 */
export default function ScheduleOverviewGate() {
  const user = useAuthUser();
  const role = parseUserRole(user);
  const { hasPermission, loading } = usePortalPermissions();
  const isOwner = isFleetOwnerRole(role);
  const permission = isOwner ? 'owner_schedule.view' : 'jobs.view';

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (!hasPermission(permission)) {
    if (isAdminRole(role)) return <Navigate to="/dashboard" replace />;
    if (isOwner) return <Navigate to="/jobs" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PermissionRoute allowIdentity={['admin', 'fleet_owner']} permission={permission}>
      <ScheduleOverview />
    </PermissionRoute>
  );
}
